import TextSection from "@/components/TextSection/TextSection";
import { useAuth } from "@/hooks/auth";
import JumboButton from "@ingka/jumbo-button";
import { useNavigate } from "react-router";
import { DELIVERY_TYPES } from "./constants";

export const SelectUploadTypePage = () => {
  const navigate = useNavigate();
  const isAdmin = useAuth().user.isAdmin;

  return (
    <div className="center">
      <TextSection
        className="max-w-[37rem] text-center"
        heading={isAdmin ? "Type of upload" : "Request an upload to Ingka DAM"}
        text="Please note that the assets will be renamed automatically according to the set naming standard in Ingka DAM. This ensures that all asset names are unique and findable. 
When you open an approved request, you’ll find the new asset names listed in the overview. These new file names can also be used to search for the assets in channels such as Publicera and Ingka CMS."
      />
      <div className="mt-space250 grid auto-cols-max grid-flow-col grid-rows-2 gap-space250">
        {DELIVERY_TYPES.map(({ type, label, isDisabled }) => (
          <JumboButton
            key={type}
            label={label}
            disabled={isDisabled}
            className="h-[120px] w-[327px]"
            variant="emphasised"
            onClick={() => {
              navigate("/uploads", { state: { uploadType: type } });
            }}
          />
        ))}
      </div>
    </div>
  );
};
